import { GetStaticProps, NextPage } from 'next';

import GettingStartedPage from '@/views/getting-started/getting-started-page';

const GettingStarted: NextPage = () => {
  return <GettingStartedPage />;
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      namespaces: ['shared'],
    },
  };
};

export default GettingStarted;
